import { ADDPRODUCT, DELETEPRODUCT, MINUSPRODUCT, PLUSPRODUCT } from "./actionTypes";
import initialState from "./initialState";

const nextProductId = (product)=>{
    const maxID = product.reduce((maxID, product)=>Math.max(product.id, maxID), -1);
    return maxID + 1;
}

const reducer = (state = initialState, action)=>{
    switch (action.type) {
        case ADDPRODUCT:
            const {name, category, img, price, qty,stock } = action.payload;
            return [
                ...state,
                {
                    id: nextProductId(state),
                    name,
                    category,
                    img,
                    price,
                    qty,
                    stock: qty,
                },
            ]; 
        case MINUSPRODUCT:
            return state.map(product => product.id === action.payload ? {...product, qty: (product.qty - 1) <= 0 ? 0 : (product.qty - 1) } : {...product} ); 
        case PLUSPRODUCT:
            return state.map(product => product.id === action.payload ? {...product, qty: (product.qty + 1) } : {...product} );         
        case DELETEPRODUCT:
            return state.map(product => product.id === action.payload ? {...product, qty: product.stock} : {...product});
        default:
            return state;            
    }
}
export default reducer;